<template>
  <el-select
    v-model="value"
    @change="change"
    @focus="focus"
    clearable
    filterable

    placeholder="请选择DSP标签"
  >
    <el-option
      v-for="item in dspNameOptions"
      :key="item.tagId"
      :label="item.tagName"
      :value="item.tagId"
    />
  </el-select>
</template>

<script>
import { getDspTagName } from '@/api/select'
import { hot } from '@/api/hot'

export default {
  props: {
    modelValue: [String, Number],
    dspType: {
      type: Number,
      default: 1
    },
    dspId: {
      type: [String, Number],
      default: undefined
    },
    dspSlotId: {
      type: [String, Number, Array, Object],
      default: undefined
    }
  },
  emits: ['update:modelValue', 'change', 'upTag'],
  data () {
    return {
      dspNameOptions: [],
      value: undefined
    }
  },
  watch: {
    dspId () {
      if (this.multiple) {
        this.value = []
        this.change([])
      } else {
        this.value = ''
        this.change('')
      }
      // this.getDspSlotName()
    },
    dspSlotId () {
      if (this.multiple) {
        this.value = []
        this.change([])
      } else {
        this.value = ''
        this.change('')
      }
    }
  },
  created () {
    // this.getDspTagName()
  },
  methods: {
    change (item) {
      const data = {
        maker: 'dspLabelOnThe',
        onTheOrderId: item
      }
      if (item) {
        hot(data)
      }
      let dspSlotIds
      if (this.dspSlotId) {
        dspSlotIds = Object.values(this.dspSlotId).toString()
      }
      getDspTagName({
        dspId: this.dspId,
        dspSlotIds: dspSlotIds || ''
      }).then(res => {
        this.$emit('upTag', res.data[item])
      })
    },
    focus () {
      let dspSlotIds
      if (this.dspSlotId) {
        dspSlotIds = Object.values(this.dspSlotId).toString()
      }
      if (this.dspType !== 100) {
        getDspTagName({
          dspId: this.dspId || '',
          dspSlotIds: dspSlotIds || ''
        }).then(res => {
          if (res.code === 200) {
            res.data.forEach((index, item) => {
              res.data[item] = { tagId: item, tagName: index }
            })
            this.dspNameOptions = res.data
          }
        })
      } else {
        getDspTagName({
          dspId: this.dspId || '',
          dspSlotIds: dspSlotIds || ''
        }).then(res => {
          if (res.code === 200) {
            res.data.forEach((index, item) => {
              res.data[item] = { tagId: item + 1, tagName: index }
            })
            this.dspNameOptions = res.data
          }
        })
      }
    }
    // removeBlank(val) {
    //   this.value = val.replace(/^\s+|\s+$/gm, '')
    // }
  }
}
</script>
